module.exports = "<p *ngFor=\"let alert of alerts\">\n  <ngb-alert [type]=\"alert.type\" (close)=\"close(alert)\">{{ alert.message }}</ngb-alert>\n</p>"